import axiosInstance from '@/core/js/interceptor';
export const AuthService = {
    login: async (credentials) => {
        const response = await axiosInstance.post('/api/login', credentials, { validateStatus: () => true });
        if (response && response.access_token) {
            localStorage.setItem('user', JSON.stringify(response.user));
            localStorage.setItem('activeUserId', JSON.stringify(response.user.id));
            localStorage.setItem('activeBranchId', JSON.stringify(response.user.branch_id));
            localStorage.setItem('menu', JSON.stringify(response.menu));
            localStorage.setItem('permissions', JSON.stringify(response.permissions));
            localStorage.setItem('userBranches', JSON.stringify(response.userBranches));
            localStorage.setItem('token', response.access_token);
            localStorage.setItem('userAccountingPeriods', JSON.stringify(response.userAccountingPeriods));
            let activeAccountingPeriod = response.userAccountingPeriods.find((period) => period.is_active === '1');
            if (!activeAccountingPeriod) {
                activeAccountingPeriod = [...response.userAccountingPeriods].sort((a, b) => Number(b.accounting_period_id) - Number(a.accounting_period_id))[0];
            }
            localStorage.setItem('activeAccountingPeriodId', JSON.stringify(activeAccountingPeriod.accounting_period_id));
        }
        return response;
    },
    logout: () => {
        localStorage.removeItem('user');
        localStorage.removeItem('activeUserId');
        localStorage.removeItem('activeBranchId');
        localStorage.removeItem('menu');
        localStorage.removeItem('permissions');
        localStorage.removeItem('userBranches');
        localStorage.removeItem('token');
        localStorage.removeItem('userAccountingPeriods');
        localStorage.removeItem('activeAccountingPeriodId');
        delete axiosInstance.defaults.headers.common['Authorization'];
    },
    getUser: () => {
        return JSON.parse(localStorage.getItem('user'));
    },
    getUserRoleId: () => {
        const data = JSON.parse(localStorage.getItem('userBranches'));
        return data?.[0]?.role_id || null;
    },
    getActiveUserId: () => {
        return JSON.parse(localStorage.getItem('activeUserId'));
    },
    getActiveBranchId: () => {
        return JSON.parse(localStorage.getItem('activeBranchId'));
    },
    getActiveAccountingPeriodId: () => {
        return JSON.parse(localStorage.getItem('activeAccountingPeriodId'));
    },
    getUserMenu: () => {
        return JSON.parse(localStorage.getItem('menu'));
    },
    getPermission: () => {
        return JSON.parse(localStorage.getItem('permissions'));
    },
    isAuthenticated: () => {
        return !!localStorage.getItem('user');
    },
    getAccountingPeriod() {
        const id = JSON.parse(localStorage.getItem('activeAccountingPeriodId'));
        const periods = JSON.parse(localStorage.getItem('userAccountingPeriods') || '[]');
        const period = periods.find((p) => p.accounting_period_id === id);
        return period;
    },
    getUserAccountingPeriods() {
        return JSON.parse(localStorage.getItem('userAccountingPeriods') || '[]');
    },
    getUserBranches() {
        return JSON.parse(localStorage.getItem('userBranches') || '[]');
    }
};
